import { render, staticRenderFns } from "./Respaldos.vue?vue&type=template&id=4caa87e6&scoped=true&"
import script from "./Respaldos.vue?vue&type=script&lang=ts&"
export * from "./Respaldos.vue?vue&type=script&lang=ts&"
import style0 from "./Respaldos.vue?vue&type=style&index=0&id=4caa87e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4caa87e6",
  null
  
)

export default component.exports